import { CvMarkerType, MapMarkerData } from '../map-utils';
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFocusedLocation, selectValidationHistory } from '../../location-list/state/location-list-selectors';
import { CvMapSignalStore } from './cv-map-signal-store';

const cvMapSignalStoreInitialState: CvMapSignalStore = {
  markers: [],
  infoWindowMarkerId: null,
  autocompleteMarker: null,
  customMarker: null,
  hoveredMarkerId: null,
  continueAfterValidation: false,
  mapsFullyRendered: false,
  streetViewLoading: false,
  mapLoading: false,
};

export const withCvMapState = () =>
    signalStoreFeature(
        withState(cvMapSignalStoreInitialState),
        withComputed((signalStore, store = inject(Store)) => {
          const focusedLocation = store.selectSignal(selectFocusedLocation);
          const validationData = store.selectSignal(selectValidationHistory);

          return {
            lastValidation: computed(() => {
              const vd = validationData();

              return focusedLocation()?.verified && vd?.[0] ?
                  vd[0] :
                  null;
            }),
            infoWindowMarker: computed(() => {
              const id = signalStore.infoWindowMarkerId();
              if (!id) return null;
              if (id === CvMarkerType.CUSTOM) return signalStore.customMarker();

              return signalStore.markers()?.find(m => m.id === id);
            }),
          };
        }),
        withMethods((signalStore) => ({
          // Updaters
          updateMarkers: (markers: MapMarkerData[]) => patchState(signalStore, { markers }),
          updateInfoWindowMarkerId: (infoWindowMarkerId: string) => patchState(signalStore, { infoWindowMarkerId }),
          updateAutocompleteMarker: (autocompleteMarker: MapMarkerData) => patchState(signalStore, { autocompleteMarker }),
          updateCustomMarker: (customMarker: MapMarkerData) => patchState(signalStore, { customMarker }),
          updateHoveredMarkerId: (hoveredMarkerId: string) => patchState(signalStore, { hoveredMarkerId }),
          updateContinueAfterValidation: (continueAfterValidation: boolean) => patchState(signalStore, { continueAfterValidation }),
          updateMapsFullyRendered: (mapsFullyRendered: boolean) => patchState(signalStore, { mapsFullyRendered }),
          updateStreetViewLoading: (streetViewLoading: boolean) => patchState(signalStore, { streetViewLoading }),
          updateMapLoading: (mapLoading: boolean) => patchState(signalStore, { mapLoading }),
        })),
    );